import { Component, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TableModule, TableRowSelectEvent } from 'primeng/table';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { BestyrelseService } from '@features/letpensiondk/letpensiondk-bestyrelse/bestyrelse.service';
import { PrimeTemplate } from 'primeng/api';
import { Checkbox } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { InputText } from 'primeng/inputtext';
import { Toolbar } from 'primeng/toolbar';

@Component({
  selector: 'app-letpensiondk-bestyrelse-list',
  imports: [
    DatePipe,
    PrimeTemplate,
    TableModule,
    TableRowDirective,
    Checkbox,
    FormsModule,
    IconField,
    InputIcon,
    InputText,
    Toolbar
  ],
  templateUrl: './letpensiondk-bestyrelse-list.component.html',
  styleUrl: './letpensiondk-bestyrelse-list.component.css'
})
export class LetpensiondkBestyrelseListComponent {
  bestyrelseService = inject(BestyrelseService);

  data = this.bestyrelseService.datasource.data;

  onRowSelect(e: TableRowSelectEvent) {
    this.bestyrelseService.selectBestyrelsesmedlem(e.data);
  }

}
